$(function() {
    $('.open-menu').click(function() {
        $('body').addClass('open-nav');
    });
    $('.close-menu').click(function() {
        $('body').removeClass('open-nav');
    });
});
